import { FC } from "react";
import { MuiModal } from "./MuiModal";
import { useSiteCore } from "../../hooks/useSiteCore";
import { MuiTypography } from "../typography/MuiTypography";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";

interface WarningModalProps {
  show: boolean;
  onClose: () => void;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick?: () => void;
  primaryButtonTitle?: string;
  secondaryButtonTitle?: string;
  labelContent: string | React.JSX.Element;
  modalTitle?: string;
  showSecondaryButton?: boolean;
  isLabelHTMLContent?: boolean;
  keepMounted?: boolean;
}

export const WarningConfirmationModal: FC<WarningModalProps> = ({
  show,
  onClose,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonTitle,
  secondaryButtonTitle,
  labelContent,
  modalTitle,
  showSecondaryButton = true,
  isLabelHTMLContent = false,
  keepMounted = false,
}) => {
  const { commonLabels } = useSiteCore();

  return (
    <MuiModal
      keepMounted={keepMounted}
      id={COMPONENT_IDS.CONFIRMATION_MODAL}
      open={show}
      onClose={onClose}
      title={modalTitle ?? commonLabels.warning}
      primaryButtonTitle={primaryButtonTitle ?? commonLabels.yes}
      secondaryButtonTitle={secondaryButtonTitle ?? commonLabels.cancel}
      onPrimaryButtonClick={onPrimaryButtonClick}
      onSecondaryButtonClick={onSecondaryButtonClick ?? onClose}
      showSecondaryButton={showSecondaryButton}
    >
      {isLabelHTMLContent ? (
        <MuiTypography
          component="label"
          variant="h3"
          dangerouslySetInnerHTML={{
            __html: typeof labelContent === "string" ? labelContent : "",
          }}
        />
      ) : (
        <MuiTypography component="label" variant="h3">
          {labelContent}
        </MuiTypography>
      )}
    </MuiModal>
  );
};
